import store from '../store'

export default [
  {
    path: '/relatorios/cidade',
    name: 'relatorios-cidade-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getCidades')
      await store.commit('setRelatorio', [])
      next()
    },
    meta: {
      title: 'Relatórios de cidades',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/cidade'
      )
    }
  },
  {
    path: '/relatorios/cidade/cliente/ativo/exibir',
    name: 'relatorios-cidade-cliente-ativo-show',
    beforeEnter: async (to, from, next) => {
      const { cidade } = store.getters.variaveis
      await store.dispatch('getCidade', {
        id: Number(cidade)
      })
      await store.dispatch('getRelatorioCidadeClienteAtivo', {
        cidade: Number(cidade)
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: false,
      title: 'Relatório de clientes ativos (por cidade)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/cidade/filtros/cliente/ativo'
      )
    }
  },
  {
    path: '/relatorios/cidade/cliente/inativo/exibir',
    name: 'relatorios-cidade-cliente-inativo-show',
    beforeEnter: async (to, from, next) => {
      const { cidade } = store.getters.variaveis
      await store.dispatch('getCidade', {
        id: Number(cidade)
      })
      await store.dispatch('getRelatorioCidadeClienteInativo', {
        cidade: Number(cidade)
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: false,
      title: 'Relatório de clientes inativos (por cidade)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/cidade/filtros/cliente/inativo'
      )
    }
  },
  {
    path: '/relatorios/cidade/lactacao/exibir',
    name: 'relatorios-cidade-lactacao-show',
    beforeEnter: async (to, from, next) => {
      const { cidade, inicial, final } = store.getters.variaveis
      await store.dispatch('getCidade', {
        id: Number(cidade)
      })
      await store.dispatch('getRelatorioCidadeLactacao', {
        cidade: Number(cidade),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de animais em lactação (por cidade)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/cidade/filtros/lactacao'
      )
    }
  },
  {
    path: '/relatorios/cidade/geolocalizacao/exibir',
    name: 'relatorios-cidade-geolocalizacao-show',
    beforeEnter: async (to, from, next) => {
      const { cidade } = store.getters.variaveis
      await store.dispatch('getCidade', {
        id: Number(cidade)
      })
      await store.dispatch('getRelatorioCidadeGeolocalizacao', {
        cidade: Number(cidade)
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: false,
      title: 'Relatório de dados dos clientes (por cidade)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/cidade/filtros/geolocalizacao'
      )
    }
  }
]
